import { useMutation, useQueryClient } from '@tanstack/react-query';
import { Endpoint, QueryKey } from '@/constants';
import { postData } from '@/utils/postData';

export const useSetDeliveryMethod = () => {
  const queryClient = useQueryClient();

  const { isPending, mutate } = useMutation({
    mutationFn: postData(Endpoint.SetShippingMethod),
    onSuccess: data => {
      if (data.isSuccess) {
        queryClient.invalidateQueries({ queryKey: [QueryKey.GetCart] });
      }
    },
  });

  return { setShippingMethod: mutate, isPending };
};
